import UploadItemStatus from "./UploadItemStatus";
const isCompletedState = (status) => {
    return UploadItemStatus.Completed === status;
};
export default isCompletedState;
